import script from "./OfBusinessPayments.vue?vue&type=script&setup=true&lang=js"
export * from "./OfBusinessPayments.vue?vue&type=script&setup=true&lang=js"

import "./OfBusinessPayments.vue?vue&type=style&index=0&id=5e283415&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e283415"]])

export default __exports__